import { sectionThemes } from './WallOfReviews';
import { ReviewCard } from './ReviewCard';

// Standalone layout for the 2-card variant_format - kept separate from the
// 6-card grid/carousel layout so the two don't share conditional markup.
export default function TwoCardWallOfReviews({ entry, position }) {
  const { uid, color_theme, heading, review_card } = entry ?? {};
  const reviewCards = review_card ?? [];
  const theme =
    sectionThemes[color_theme?.toLowerCase().trim()] ??
    sectionThemes['warm pewter 30%'];
  const cardStyles = {
    'warm pewter 30%': ['bg-warm-pewter-80', 'bg-warm-pewter-60'],
    'warm pewter 80%': ['bg-crisp-white', 'bg-warm-pewter-30'],
    'parlor green': ['bg-parlor-green-10', 'bg-parlor-green-20']
  };
  const normalizedColorTheme = color_theme?.toLowerCase().trim();
  const twoCardCardClass =
    cardStyles[normalizedColorTheme] ?? cardStyles['warm pewter 30%'];

  return (
    <section
      id={`${uid}_${position}`}
      data-name="wall-of-reviews"
      className={`flex w-full flex-col items-center justify-center py-20 lg:py-30 ${theme.section}`}
    >
      <div className="2lg:max-w-360 2lg:px-0 2lg:gap-15 mx-auto flex w-full max-w-90 flex-col items-center justify-center gap-10 px-5 sm:max-w-3xl sm:gap-15 sm:px-10 lg:max-w-full lg:px-10">
        <div className="2lg:max-w-301 2lg:gap-20 flex w-full max-w-301 flex-col items-start gap-10 sm:gap-10 sm:self-stretch lg:flex-row lg:items-center lg:justify-center lg:gap-10 lg:self-auto">
          {heading && (
            <div className="2lg:w-[281.2px] flex w-full flex-col items-start gap-15 lg:w-70 lg:shrink-0 lg:self-stretch">
              <h2
                className={`h3 lg:h2 mx-auto w-55 text-center sm:w-full lg:text-left ${theme.heading}`}
              >
                {heading}
              </h2>
            </div>
          )}

          {reviewCards.length > 0 && (
            <div className="2lg:w-[842.8px] 2lg:flex-none grid w-full grid-cols-1 items-start gap-6 sm:flex sm:flex-row sm:items-start sm:gap-3 lg:flex-1 lg:flex-wrap lg:content-start lg:items-start lg:justify-center lg:gap-x-3 lg:gap-y-5">
              {reviewCards.map((card, index) => (
                <ReviewCard
                  key={card._metadata?.uid ?? index}
                  card={card}
                  cardClass={
                    index === 0 ? twoCardCardClass[0] : twoCardCardClass[1]
                  }
                  quoteClass={
                    index === 0
                      ? 'h5 lg:text-lg 2lg:h4'
                      : 'h6 lg:text-base 2lg:h5'
                  }
                  alignClass="items-start justify-start"
                  textAlignClass="text-left"
                  dateRowClass="flex-row items-end justify-between"
                  dateTextClass={
                    index === 1 && normalizedColorTheme === 'parlor green'
                      ? 'text-parlor-green-80'
                      : undefined
                  }
                  productNameClass={
                    index === 1 ? '@max-[300px]:w-25' : undefined
                  }
                  baseClass={
                    index === 0
                      ? 'flex w-full flex-col items-start gap-5 self-stretch p-8 sm:w-[405.6px] sm:gap-5 sm:self-auto lg:min-w-70 lg:flex-1 lg:gap-5 lg:p-10 2lg:w-[498.48px] 2lg:flex-none 2lg:shrink-0'
                      : '@container flex w-full flex-col items-start gap-3 self-stretch p-8 sm:flex-1 sm:gap-3 sm:self-auto lg:min-w-70 lg:flex-1 lg:gap-5 lg:p-10 2lg:flex-1'
                  }
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
